import { useEffect, useRef } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import './App.css';
import '@fortawesome/fontawesome-free/css/all.css';
import Callback from './pages/callback/Callback';
import Login from './pages/login/Login';
import Home from './pages/home/Home';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import Header from './components/header/header';
import Footer from './components/footer/footer';
import Notification from './components/notification/notification';
import Sidebar, { ContactButton } from './components/sidebar/sidebar';
import Faq from './pages/faq/Faq';
import { Helmet } from 'react-helmet';
import { useAuthentication, useI18n } from './hooks';

import FlashMessage from './components/flash_message/flash_message';
import { DisplayMessageProvider } from './displayMessageContext';

import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security, LoginCallback } from '@okta/okta-react';

import log from 'loglevel';
import Admin from './pages/admin/Admin';
import AddUser from './pages/admin/AddUser';
import EditUser from './pages/admin/EditUser';

log.setDefaultLevel('silent');
if (import.meta.env.VITE_ENV === 'development') {
   log.setLevel('trace');
}

export const oktaAuth = new OktaAuth({
   issuer: import.meta.env.VITE_OKTA_DOMAIN,
   clientId: import.meta.env.VITE_OKTA_CLIENT_ID,
   redirectUri: window.location.origin + '/login/callback',
});

function App() {
   const { i18n } = useI18n();
   const { signed_in } = useAuthentication();

   const refContainer = useRef(signed_in);
   useEffect(() => {
      refContainer.current = signed_in;
   });
   const justLoggedOut = !!refContainer.current && !signed_in;

   const navigate = useNavigate();

   async function restoreOriginalUri(_oktaAuth, originalUri) {
      navigate(toRelativeUrl(originalUri || '/', window.location.origin), {
         replace: true,
      });
   }

   return (
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
         <DisplayMessageProvider>
            <div>
               <Helmet>
                  <title>{i18n('index.title')}</title>
                  <meta name="description" content={i18n('index.meta')}></meta>
                  <script>
                     {`(function () {
                document.querySelectorAll('iframe').forEach(function(element){
                  element.setAttribute('sandbox', 'allow-scripts allow-popups allow-forms');
                })
            })();`}
                  </script>
               </Helmet>
               <Header />
               {justLoggedOut && <FlashMessage message={'signed_out'} />}
               <Routes>
                  <Route path="/login/callback" element={<LoginCallback />} />
                  <Route path="/callback" element={<Callback />} />
                  <Route path="/faq" element={<Faq />} />
                  <Route
                     path="/home"
                     element={
                        <PrivateRoute>
                           <Home />
                        </PrivateRoute>
                     }
                  />
                  <Route
                     path="/admin"
                     element={
                        <AdminRoute>
                           <Admin />
                        </AdminRoute>
                     }
                  />
                  <Route
                     path="/admin/add"
                     element={
                        <AdminRoute>
                           <AddUser />
                        </AdminRoute>
                     }
                  />
                  <Route
                     path="/admin/user/:id"
                     element={
                        <AdminRoute>
                           <EditUser />
                        </AdminRoute>
                     }
                  />
                  <Route path="/" element={<Login />} />
               </Routes>
               <Notification />
               <Footer />
               <ContactButton />
               <Sidebar />
            </div>
         </DisplayMessageProvider>
      </Security>
   );
}

export default App;
